import { useQuery, useQueryClient } from "@tanstack/react-query";
import { chatApi, CHAT_DOMAIN, CHAT_READ_MESSAGE_ENDPOINT } from "api/chatApi";
import { PATIENT_DOMAIN, PATIENT_LIST_ENDPOINT } from "api/patientApi";
import { useCallback, useEffect } from "react";
import { useRecoilValue } from "recoil";
import { patientAtom } from "recoil/patientAtom";
import ChatContent from "./content/ChatContent";

export default function Chat() {
  const queryClient = useQueryClient();
  const patientState = useRecoilValue(patientAtom);
  const messageReadQueryFn = useCallback(
    () => chatApi.read(`${patientState?.patientId}`),
    [patientState]
  );

  const { refetch: readMessage } = useQuery(
    [CHAT_DOMAIN, CHAT_READ_MESSAGE_ENDPOINT],
    messageReadQueryFn,
    {
      enabled: false,
      onSuccess: (data) => {
        queryClient.invalidateQueries([PATIENT_DOMAIN, PATIENT_LIST_ENDPOINT]);
      },
    }
  );

  useEffect(() => {
    readMessage();
    return () => {
      readMessage();
    };
  }, []);
  return (
    <>
      <div className="w-full h-full overflow-x-hidden">
        <ChatContent />
      </div>
    </>
  );
}
